import React, { useState, useMemo, useEffect } from "react";
import { Box, Button, Typography, FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export default function SinglePdfViewer({ pdfFiles = [] }) {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  // Group PDFs by folder
  const grouped = useMemo(() => {
    const map = {};

    pdfFiles.forEach((fileObj) => {
      const [category] = fileObj.filename.split("/");
      if (!map[category]) map[category] = [];
      map[category].push(fileObj);
    });

    return map;
  }, [pdfFiles]);

  // Auto-select first category
  useEffect(() => {
    const cats = Object.keys(grouped);
    if (cats.length > 0 && !selectedCategory) {
      setSelectedCategory(cats[0]);
    }
  }, [grouped]);

  // Auto-select first file of the category
  useEffect(() => {
    const files = grouped[selectedCategory] || [];
    if (files.length > 0) {
      setSelectedFile(files[0]);
    }
  }, [selectedCategory, grouped]);

  const filesInCategory = grouped[selectedCategory] || [];

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
      {/* ROW CONTAINER */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "100%",
        }}
      >

        {/* CATEGORY BUTTONS (75%) */}
        <Box
          sx={{
            display: "flex",
            gap: 1,
            flexWrap: "wrap",
            width: "75%",
            alignItems: "center",
          }}
        >
          {Object.keys(grouped).map((cat) => (
            <Button
              key={cat}
              size="small"
              variant={selectedCategory === cat ? "contained" : "contained"}
              onClick={() => setSelectedCategory(cat)}
              sx={{
                minWidth: 40,
                padding: "2px 6px",
                fontSize: "0.75rem",
                height: "28px",   // FINAL BUTTON HEIGHT
              }}
            >
              {cat.substring(0, 1).toUpperCase()}
            </Button>
          ))}
        </Box>

        {/* FILE DROPDOWN (25%) */}
        <Box sx={{ width: "25%" }}>
          <FormControl fullWidth size="small" sx={{ height: "28px" }}>
            <Select
              displayEmpty
              value={selectedFile?.url || ""}
              onChange={(e) => {
                const file = filesInCategory.find(f => f.url === e.target.value);
                setSelectedFile(file);
              }}
              sx={{
                height: "28px !important",
                fontSize: "0.75rem",
                display: "flex",
                alignItems: "center",
                padding: "0 !important",
              }}
            >
              {/* Placeholder */}
              <MenuItem value="" disabled sx={{ fontSize: "0.75rem" }}>
                Select File
              </MenuItem>

              {filesInCategory.map((file) => {
                const fileName = file.filename.split("/")[1];
                return (
                  <MenuItem key={file.url} value={file.url} sx={{ fontSize: "0.8rem" }}>
                    {fileName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </Box>

      {/* PDF VIEWER */}
      <Box
        sx={{
          width: "100%",
          height: "70vh",
          border: "1px solid #ccc",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {selectedFile ? (
          <iframe
           key={selectedFile?.url}
            src={selectedFile?.url}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          />
        ) : (
          <Typography>No file selected.</Typography>
        )}
      </Box>
    </Box>
  );
}
